import Vue from 'vue';
import conversationMessage from '@telexpress/vue-conversation-message';
import '@telexpress/vue-conversation-message/dist/vue-conversation-message.css';

Vue.use(conversationMessage, { externalToolAPIUrl: Vue.env.VUE_APP_ExternalToolApi, COMUrl: Vue.env.VUE_APP_COM_DOMAIN });
